<script setup lang="ts">
withDefaults(defineProps<{ size?: number; title?: string }>(), { size: 32, title: 'Glamora' })
</script>

<template>
  <!-- Glamora brand mark (self-contained background, safe on light and dark surfaces) -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    :width="size"
    :height="size"
    role="img"
    :aria-label="title"
    class="shrink-0 rounded-[25%] dark:ring-1 dark:ring-white/10"
  >
    <title>{{ title }}</title>
    <rect width="64" height="64" rx="16" fill="#C2185B"/><path d="M44.5 22.5 A15 15 0 1 0 47 35 H33" fill="none" stroke="#fff" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/><path d="M50 8 L52 13 L57 15 L52 17 L50 22 L48 17 L43 15 L48 13 Z" fill="#FFD6E7"/>
  </svg>
</template>
